import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './JoinLobby.css';
import Button from '../ui/Button';
import { addPlayerToLobby, getLobby } from '../../firebase/services';
import { useGame } from '../../contexts/GameContext';

const JoinLobby = ({ onBack }) => {
  const [playerName, setPlayerName] = useState('');
  const [lobbyCode, setLobbyCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  
  const { 
    setPlayerId, 
    setPlayerName: setContextPlayerName, 
    setLobbyCode: setContextLobbyCode,
    leaveGame
  } = useGame();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!playerName.trim()) {
      setError('Lütfen bir isim girin');
      return;
    }
    
    if (!lobbyCode.trim()) {
      setError('Lütfen bir lobi kodu girin');
      return;
    }
    
    // Convert to uppercase
    const formattedCode = lobbyCode.toUpperCase().trim();
    
    // Clear any previous errors
    setError('');
    setIsLoading(true);
    
    try {
      // Check if lobby exists
      await getLobby(formattedCode);
      
      // Join the lobby
      const playerId = await addPlayerToLobby(formattedCode, playerName);
      
      // Update game context
      setPlayerId(playerId);
      setContextPlayerName(playerName);
      setContextLobbyCode(formattedCode);
      
      // Navigate to lobby page
      navigate(`/lobby/${formattedCode}`);
      console.log(`Lobiye başarıyla katılıldı, yönlendiriliyor: /lobby/${formattedCode}`);
    } catch (error) {
      console.error("Lobiye katılırken hata:", error);
      
      if (error.message === 'Lobi bulunamadı') {
        setError('Lobi bulunamadı. Kodu kontrol edin.');
      } else if (error.message === 'Oyun zaten başlamış') {
        setError('Bu lobiye katılamazsınız. Oyun zaten başlamış.');
      } else if (error.message === 'Bu isimde bir oyuncu zaten var') {
        setError('Bu isimde bir oyuncu zaten var. Farklı bir isim deneyin.');
      } else {
        setError('Lobiye katılınamadı. Lütfen tekrar deneyin.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="join-lobby">
      <h2 className="join-lobby__title">Lobiye Katıl</h2>
      
      <form onSubmit={handleSubmit} className="join-lobby__form">
        <div className="join-lobby__input-group">
          <label htmlFor="lobbyCode" className="join-lobby__label">Lobi Kodu</label>
          <input
            type="text"
            id="lobbyCode"
            className="join-lobby__input join-lobby__input--code"
            value={lobbyCode}
            onChange={(e) => setLobbyCode(e.target.value.toUpperCase())}
            placeholder="XXXX"
            maxLength={4}
            autoComplete="off"
            disabled={isLoading}
          />
        </div>
        
        <div className="join-lobby__input-group">
          <label htmlFor="playerName" className="join-lobby__label">İsminiz</label>
          <input
            type="text"
            id="playerName"
            className="join-lobby__input"
            value={playerName}
            onChange={(e) => setPlayerName(e.target.value)}
            placeholder="İsminizi girin"
            maxLength={15}
            autoComplete="off"
            disabled={isLoading}
          />
        </div>
        
        {error && <div className="join-lobby__error">{error}</div>}
        
        <div className="join-lobby__buttons">
          <Button 
            onClick={() => {
              console.log('Geri butonuna tıklandı, oyun durumu sıfırlanıyor ve ana sayfaya yönlendiriliyor');
              // Reset game context state to clear playerId and prevent auto-redirect
              leaveGame();
              // Navigate to home page
              navigate('/');
            }} 
            variant="secondary" 
            disabled={isLoading}
          >
            Geri
          </Button>
          <Button 
            type="submit" 
            disabled={isLoading || !playerName.trim() || !lobbyCode.trim()}
          >
            {isLoading ? 'Katılınıyor...' : 'Lobiye Katıl'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default JoinLobby;
